import { __rest } from 'tslib';
import 'react/jsx-runtime';
import React__default from 'react';

function mergeProps(...propList) {
    return propList.reduce((props, next) => {
        const { style, className } = next, rest = __rest(next, ["style", "className"]);
        props = Object.assign(Object.assign({}, props), rest);
        if (style) {
            props.style = props.style ? Object.assign(Object.assign({}, (props.style || {})), (style || {})) : style;
        }
        if (className) {
            props.className = props.className ? `${props.className} ${className}` : className;
        }
        if (props.className === '') {
            delete props.className;
        }
        return props;
    }, {});
}
function handlePropGetter(prevProps, userProps, meta) {
    // Handle a lambda, pass it the previous props
    if (typeof userProps === 'function') {
        return handlePropGetter({}, userProps(prevProps, meta));
    }
    // Handle an array, merge each item as separate props
    if (Array.isArray(userProps)) {
        return mergeProps(prevProps, ...userProps);
    }
    // Handle an object by default, merge the two objects
    return mergeProps(prevProps, userProps);
}
const makePropGetter = (hooks, meta = {}) => {
    return (userProps = {}) => [...hooks, userProps].reduce((prev, next) => handlePropGetter(prev, next, Object.assign(Object.assign({}, meta), { userProps })), {});
};
function useGetLatest(obj) {
    const ref = React__default.useRef();
    ref.current = obj;
    return React__default.useCallback(() => ref.current, []);
}
// SSR has issues with useLayoutEffect still, so use useEffect during SSR
const safeUseLayoutEffect = typeof document !== 'undefined' ? React__default.useLayoutEffect : React__default.useEffect;
function useMountedLayoutEffect(fn, deps) {
    const mountedRef = React__default.useRef(false);
    safeUseLayoutEffect(() => {
        if (mountedRef.current) {
            fn();
        }
        mountedRef.current = true;
        // eslint-disable-next-line
    }, deps);
}
function getFirstDefined(...args) {
    for (let i = 0; i < args.length; i += 1) {
        if (typeof args[i] !== 'undefined') {
            return args[i];
        }
    }
}
let passiveSupported = null;
function passiveEventSupported() {
    // memoize support to avoid adding multiple test events
    if (typeof passiveSupported === 'boolean')
        return passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive() {
                supported = true;
                return false;
            },
        };
        window.addEventListener('test', null, options);
        window.removeEventListener('test', null, options);
    }
    catch (err) {
        supported = false;
    }
    passiveSupported = supported;
    return passiveSupported;
}

export { getFirstDefined, makePropGetter, passiveEventSupported, safeUseLayoutEffect, useGetLatest, useMountedLayoutEffect };
//# sourceMappingURL=utils.js.map
